import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import intro292Background from './img/intro292mobile-mainbackground-908BF82D-C86A-4DC2-ADCE-0D892E52EA7A.jpg'
import intro292MobileMask from './img/intro292mobile-mask-overlay-D85F84C9-B505-4F54-B8BA-FB0D0FB33135.png'
import intro292MobileTexture from './img/intro292mobile-texture-2C5A05D7-9ABD-4DDE-92BD-4952295653DF.svg'
import intro292DesktopMask from './img/intro292desktop-mask-overlay-16FECBDC-8EDD-4CB9-B9B2-007BC8070C1E.png'
import intro292DesktopTexture from './img/intro292desktop-texture-06D7F698-05EF-462A-B9C8-67BC9FA23DB5.svg'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0

  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro292">
      <div className="intro292mobile screen">
        <img
          className="main-background-xWPvR2"
          src={background || intro292Background}
        />
        <img className="mask-overlay-xWPvR2" src={intro292MobileMask} />
        <img className="texture-xWPvR2" src={intro292MobileTexture} />
        <div className="container-center-horizontal">
          <div className="button-xWPvR2">
            <p
              className="site-de-casamento-e-Jg1bzC"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-Jg1bzC" onClick={onSkipIntro}>
              <div className="button-BhHZuU"></div>
              <div className="pular-introduo-BhHZuU">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-xWPvR2">
            <div className="couple-initials-s50dsk bp2-animate-enter notranslate">
              {coupleSimplifiedName.bride}
              {coupleSimplifiedName.groom && `/${coupleSimplifiedName.groom}`}
            </div>
            <div
              className={`vo-se-casar-s50dsk bp2-animate-enter1 ${
                isMac && 'fix-macos-mobile'
              }`}
            >
              {text}
            </div>
          </div>
        </div>
      </div>
      <div className="intro292desktop screen">
        <img
          className="main-background-Gqgrxu"
          src={background || intro292Background}
        />
        <img className="mask-overlay-Gqgrxu" src={intro292DesktopMask} />
        <img className="texture-Gqgrxu" src={intro292DesktopTexture} />
        <div className="container-center-horizontal">
          <div className="button-Gqgrxu">
            <p
              className="site-de-casamento-e-NJlU0o"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-NJlU0o" onClick={onSkipIntro}>
              <div className="button-NXlsXb"></div>
              <div className="pular-introduo-NXlsXb">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-Gqgrxu">
            <h1 className="couple-initials-CZfBpR bp1-animate-enter notranslate">
              {coupleSimplifiedName.bride}
              {coupleSimplifiedName.groom && `/${coupleSimplifiedName.groom}`}
            </h1>
            <div
              className={`vo-se-casar-CZfBpR bp1-animate-enter1 ${
                isMac && 'fix-macos'
              }`}
            >
              {text}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
